import React, { forwardRef } from 'react';

const InputSamplesIcon = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99993 1.33334H5.66659V14.118L8.53326 11.2513C8.65899 11.1299 8.8274 11.0627 9.00219 11.0642C9.17699 11.0657 9.3442 11.1359 9.4678 11.2595C9.59141 11.3831 9.66152 11.5503 9.66304 11.7251C9.66456 11.8999 9.59737 12.0683 9.47593 12.194L6.17859 15.4913C6.02382 15.6461 5.84007 15.769 5.63783 15.8527C5.43559 15.9365 5.21883 15.9796 4.99993 15.9796C4.78102 15.9796 4.56426 15.9365 4.36202 15.8527C4.15978 15.769 3.97603 15.6461 3.82126 15.4913L0.521259 12.1913C0.396253 12.066 0.326167 11.8961 0.326417 11.7191C0.326667 11.542 0.397233 11.3723 0.522592 11.2473C0.647951 11.1223 0.817834 11.0522 0.994868 11.0525C1.1719 11.0527 1.34159 11.1233 1.46659 11.2487L4.33326 14.1153V1.33334H0.999925C0.823114 1.33334 0.653545 1.26311 0.528521 1.13808C0.403497 1.01306 0.333259 0.843488 0.333259 0.666677C0.333259 0.489866 0.403497 0.320296 0.528521 0.195272C0.653545 0.0702486 0.823114 1.04904e-05 0.999925 1.04904e-05H8.99993C9.17674 1.04904e-05 9.34631 0.0702486 9.47133 0.195272C9.59636 0.320296 9.66659 0.489866 9.66659 0.666677C9.66659 0.843488 9.59636 1.01306 9.47133 1.13808C9.34631 1.26311 9.17674 1.33334 8.99993 1.33334Z"
        fill="#031B4A"
      />
    </svg>
  );
});

export default InputSamplesIcon;
